define("SDB.FindPerfectFit.EntryPoint", ["SDB.FindPerfectFit.View"], function (
  SDBFindPerfectFitView
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent("Layout");
      var env = container.getComponent("Environment");
      var images = env.getConfig("SDBFindPerfectFit.Images");
      if (layout) {
        layout.addChildView("SDB.FindPerfectFit.View", function () {
          return new SDBFindPerfectFitView({ container: container });
        });
      }
      if (images) {
        images.forEach(function (img) {
          var linkElement = document.createElement("link");
          linkElement.rel = "preload";
          linkElement.href =
            img.image + "?resizeid=6&resizeh=1600&resizew=1600";
          linkElement.as = "image";
          document.head.appendChild(linkElement);
        });
      }
    },
  };
});
